// import Swiper and modules styles
import "../../node_modules/swiper/swiper.scss";
import "../../node_modules/swiper/modules/navigation/navigation.scss";
import "../../node_modules/swiper/modules/pagination/pagination.scss";
import "../../node_modules/swiper/modules/lazy/lazy.scss";
import "../../node_modules/swiper/modules/free-mode/free-mode.scss";
// import '../../node_modules/swiper/modules/parallax/parallax.scss';
// import '../../node_modules/swiper/modules/effect-fade/effect-fade.scss';
import "../../node_modules/swiper/modules/scrollbar/scrollbar.scss";
import "../../node_modules/swiper/modules/mousewheel/mousewheel.scss";

import "../scss/app.scss";

import MatchHeight from "@tannerhodges/match-height";
//import { Collapse } from 'bootstrap'; // burger menu

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import "./rgpd.js";
import { menuDropdown } from "./menu.js";
import "./lottie.js";
import goToAnchor from "./goToAnchor.js";
import planingTimeline from "./planingTimeline.js";
import { activeFieldClass } from "./activeFieldClass.js";
import parallaxBloc from "./parallaxBloc.js";
//import turnOffTheLight from "./_turnOffTheLight.js";
import { googleMap } from "./google-map.js";
import "./programmeMap.js";

// import Swiper JS
import Swiper, {
	Navigation,
	Pagination,
	FreeMode,
	Lazy,
	Mousewheel,
	Keyboard,
	Scrollbar,
	Autoplay,
} from "swiper";

Swiper.use([
	Navigation,
	Pagination,
	FreeMode,
	Lazy,
	Mousewheel,
	Keyboard,
	Scrollbar,
	Autoplay,
]);

//---------------------------//
// au chargement lancement des effets d'apparation des élements
//---------------------------//
const heightHeader = () => {
	const header = document.querySelector(".fixed-header");
	const navBar = document.querySelector(".navbar");
	if (navBar) {
		let navHeight = navBar.offsetHeight;
		header.style.height = navHeight + "px";

		window.addEventListener(
			"scroll",
			function () {
				if (window.scrollY > navHeight) {
					header.classList.add("sticky");
					// setTimeout( applyHeightSubMenu(), 5000 );
				} else {
					header.classList.remove("sticky");
				}

				if (this.oldScroll > this.scrollY) {
					// scrollDirection = 'up';
					header.classList.add("sticky--up");
					// header.classList.remove('sticky--down');
				} else {
					// scrollDirection = 'down';
					header.classList.remove("sticky--up");
					// header.classList.add('sticky--down');
				}
				this.oldScroll = this.scrollY;
			},
			{ passive: true }
		);

		// --------- Real full Height
		const fullHeight = document.querySelectorAll(".full-height");

		fullHeight.forEach(function (item, i) {
			item.style.height = 100 - (navHeight / window.innerHeight) * 100 + "vh";

			if (i === fullHeight.length - 1) {
				ScrollTrigger.refresh();
			}
		});

		const fullMinHeight = document.querySelectorAll(".full-minheight");

		fullMinHeight.forEach(function (item, i) {
			item.style.minHeight =
				100 - (navHeight / window.innerHeight) * 100 + "vh";

			if (i === fullMinHeight.length - 1) {
				ScrollTrigger.refresh();
			}
		});
	}
};

const togglerMenu = () => {
	//observer, toggler
	const navbarToggler = document.querySelector(".navbar-toggler");

	if (navbarToggler) {
		navbarToggler.addEventListener("click", (event) => {
			event.preventDefault();
			const header = document.querySelector(".fixed-header");

			if (header.classList.contains("menu-open") === false) {
				header.classList.add("menu-open");
			} else {
				header.classList.remove("menu-open");
			}
		});
	}
};

heightHeader();
togglerMenu();
googleMap();

// apply same height, on slide-discover-all, with img of slider
let sameHeightDisvover = () => {
	const sliderScrollbarImg = document.querySelector(
		".slider-scrollbar .programmeItem__img"
	);
	const discoverAll = document.querySelector(".slide-discover-all");
	if (sliderScrollbarImg && discoverAll) {
		discoverAll.style.minHeight = sliderScrollbarImg.offsetHeight + "px";
	}
};

window.addEventListener("load", () => {
	parallaxBloc(); //need to wait load image
});

window.addEventListener("DOMContentLoaded", () => {
	// ----- reveal effect on load
	const itemReveal = document.querySelectorAll("[data-reveal]");
	let i;
	for (i = 0; i < itemReveal.length; i++) {
		itemReveal[i].style.opacity = 1;
		itemReveal[i].classList.add("revealed");
	}

	activeFieldClass();
	menuDropdown();
	goToAnchor();
	planingTimeline();
	sameHeightDisvover();

	const shift = document.querySelectorAll(".mediaText .shift");
	if (shift.length > 0) {
		shift.forEach((item) => {
			const shiftContent = item.querySelector(".mediaText__content");
			const shiftImg = item.querySelector(".mediaText__media");
			const content = shiftContent.querySelector(".entry-content");
			if (item.classList.contains("flex-row-reverse")) {
				//se positionne au niveau du texte de gauche
				shiftImg.style.paddingBottom =
					item.getBoundingClientRect().bottom -
					content.getBoundingClientRect().top +
					"px";
			} else {
				//se positionne au niveau du texte de droite
				shiftImg.style.paddingTop =
					content.getBoundingClientRect().top -
					shiftContent.getBoundingClientRect().top +
					"px";
			}
		});
	}

	// ---------- match height , blog list, group by 2
	const matchTitle = document.querySelectorAll(".blog-list--sm .blogItem");

	if (matchTitle.length > 0) {
		var arrayTitle = [];

		// transform nodelist en tableau
		matchTitle.forEach((item) => {
			arrayTitle.push(item);
		});

		const chunkSize = 2;
		var arrayTitleGroup = [];
		for (let i = 0; i < arrayTitle.length; i += chunkSize) {
			const chunk = arrayTitle.slice(i, i + chunkSize);
			arrayTitleGroup.push(chunk);
		}

		// on ajoute les noms des groups
		arrayTitleGroup.forEach((item, index) => {
			let group = index; // index du parent
			// on bloucle à l'intérieur de chaque groupe
			item.forEach((item) => {
				let heading = item.querySelector(".blogItem__heading");
				MatchHeight.add(heading, "post-heading-" + group);
				let content = item.querySelector(
					".blogItem__content .entry-content"
				);
				MatchHeight.add(content, "post-content-" + group);
			});
		});
	}

	// slider avec scrollbar
	const sliderScrollbar = document.querySelectorAll(".slider-scrollbar");

	if (sliderScrollbar) {
		sliderScrollbar.forEach((slider) => {
			new Swiper(slider, {
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: {
					enabled: true,
					loadPrevNext: true,
					loadOnTransitionStart: true,
				},
				watchSlidesProgress: true, // use if lazy true

				mousewheel: {
					invert: false,
					forceToAxis: false,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},

				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				centeredSlides: false,
				spaceBetween: 30,

				// scrollbar: {
				//   el: '.swiper-scrollbar',
				//   draggable: true,
				// },

				pagination: {
					el: ".swiper-scrollbar",
					type: "progressbar",
				},
				resistance: false,
				freeMode: {
					enabled: true,
					sticky: false,
					// momentumVelocityRatio: 1,
					// momentumRatio: 1.6
				},

				breakpoints: {
					// when window width is >= 480px
					991: {
						slidesPerView: "auto",
						spaceBetween: 60,
					},
				},
			});
		});
	}

	// Galerie dans l'entête de page , bloc gutemberg
	const sliderTitleBanner = document.querySelectorAll(".slider-titleBanner");
	if (sliderTitleBanner) {
		sliderTitleBanner.forEach((slider) => {
			new Swiper(slider, {
				loop: false,
				grabCursor: true,
				slidesPerView: 1,
				navigation: {
					nextEl: document.querySelector(".titleBanner--button-next"),
					prevEl: document.querySelector(".titleBanner--button-prev"),
				},
			});
		});
	}

	// galerie d'images , bloc gutemberg, page réalisation détails
	const sliderGalerie = document.querySelectorAll(".slider-galerie");

	if (sliderGalerie) {
		sliderGalerie.forEach((slider) => {
			new Swiper(slider, {
				preloadImages: false, // Disable preloading of all images if use lazy
				watchSlidesProgress: true, // use if lazy true
				lazy: {
					// Enable lazy loading
					enabled: true,
					loadPrevNext: true,
					loadOnTransitionStart: true,
				},
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},

				loop: true,
				grabCursor: true,
				slidesPerView: 1,
				resistance: false,

				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
					formatFractionCurrent: function (number) {
						return ("0" + number).slice(-2);
					},
					formatFractionTotal: function (number) {
						return ("0" + number).slice(-2);
					},
					renderFraction: function (currentClass, totalClass) {
						return (
							'<span class="' +
							currentClass +
							'"></span>' +
							" / " +
							'<span class="' +
							totalClass +
							'"></span>'
						);
					},
				},

				on: {
					init() {
						let pagination = this.pagination.$el[0];
						let slideHeight = this.visibleSlides[0].children[0]
							.offsetHeight;
						pagination.style.top = slideHeight + "px";
					},
					resize() {
						let pagination = this.pagination.$el[0];
						let slideHeight = this.visibleSlides[0].children[0]
							.offsetHeight;
						pagination.style.top = slideHeight + "px";
					},
				},
			});
		});
	}
});

const archiveGallery = document.querySelectorAll(".archive-gallery");
if (archiveGallery) {
	archiveGallery.forEach((slider) => {
		new Swiper(slider, {
			preloadImages: false, // Disable preloading of all images if use lazy
			lazy: {
				// Enable lazy loading
				enabled: true,
				loadPrevNext: true,
				loadOnTransitionStart: true,
			},
			loop: true,
			grabCursor: true,
			slidesPerView: 1,
			resistance: false,
			autoplay: true,
			delay: 2250,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
		});
	});
}

window.addEventListener("resize", () => {
	planingTimeline();
	heightHeader();
	sameHeightDisvover();
});
